import PersonaControlViewState from '../store/schema/PersonaControlViewState';
import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';
import { PersonaBlobFetchStatus } from '../store/schema/PersonaBlob';

export default mutatorAction('reInitializePersonaBlob', (personaControlKey: string) => {
    const viewState: PersonaControlViewState = getStore().viewStates.get(personaControlKey);

    if (viewState && viewState.personaBlob) {
        const { personaBlob } = viewState;
        personaBlob.blobUrl = null;
        personaBlob.FetchStatus = PersonaBlobFetchStatus.None;
    }
});
